import React from 'react'

type Parameters = {
  autoplay: boolean
  rel: boolean
}

type YouTubeEmbedProps = {
  videoId: string
  parameters?: Partial<Parameters>
}

const getSrc = (videoId: string, overrides?: Partial<Parameters>): string => {
  const parameters: Parameters = {
    autoplay: false,
    rel: false,
    ...overrides,
  }

  const srcUrl = new URL(`https://www.youtube.com/embed/${videoId}`)

  srcUrl.searchParams.set('autoplay', parameters.autoplay ? '1' : '0')
  srcUrl.searchParams.set('rel', parameters.rel ? '1' : '0')

  return srcUrl.toString()
}

export const YouTubeEmbed = ({ videoId, parameters }: YouTubeEmbedProps) => (
  <iframe
    src={getSrc(videoId, parameters)}
    title="YouTube video player"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerPolicy="strict-origin-when-cross-origin"
    allowFullScreen
    style={{ display: 'block', width: '100%', aspectRatio: '560 / 315', borderRadius: 2 }}
  />
)
